module.exports = __webpack_public_path__ + "static/media/business.87ceb0c2.png";